<template>
  <div class="company-detail-page">
    <el-card v-if="companyDetail" class="detail-card">
      <h2>{{ companyDetail.company_name }}</h2>
      <el-card class="box-card">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-descriptions title="公司信息" :column="1" border>
              <el-descriptions-item label="公司名称">{{ companyDetail.company_name }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{ companyDetail.concat_phone }}</el-descriptions-item>
              <el-descriptions-item label="邮箱">
                <ul v-if="Array.isArray(companyDetail.concat_email_list) && companyDetail.concat_email_list.length">
                  <li v-for="(email, index) in companyDetail.concat_email_list" :key="index">
                    <i class="el-icon-message"></i> {{ email }}
                  </li>
                </ul>
                <span v-else>暂无</span>
              </el-descriptions-item>
              <el-descriptions-item label="地址">{{ companyDetail.concat_address }}</el-descriptions-item>
              <el-descriptions-item label="行业">{{ companyDetail.industry }}</el-descriptions-item>
              <el-descriptions-item label="负责人">{{ companyDetail.company_leader }}</el-descriptions-item>
              <el-descriptions-item label="网址">
                <a :href="companyDetail.url" target="_blank">{{ companyDetail.url }}</a>
              </el-descriptions-item>
            </el-descriptions>
          </el-col>
          <el-col :span="12">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>公司简介</span>
              </div>
              <p>{{ companyDetail.company_introduction }}</p>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
      
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>公司历史</span>
        </div>
        <p class="company-history">{{ companyDetail.company_history || '暂无' }}</p>
      </el-card>

      <el-card v-if="companyDetail.product_list && companyDetail.product_list.length > 0" class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>产品列表</span>
        </div>
        <ul>
          <li v-for="(product, index) in companyDetail.product_list" :key="index">
            {{ product }}
          </li>
        </ul>
      </el-card>

      <el-card v-if="companyDetail.company_news_list && companyDetail.company_news_list.length > 0" class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span>公司新闻</span>
        </div>
        <ul>
          <li v-for="(news, index) in companyDetail.company_news_list" :key="index">
            {{ news }}
          </li>
        </ul>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CompanyDetailPage',
  data() {
    return {
      companyDetail: null,
      isLoading: false,
    };
  },
  created() {
    this.fetchCompanyDetail();
  },
  methods: {
    async fetchCompanyDetail() {
      const companyId = this.$route.params.id;
      if (!companyId) return;
      this.isLoading = true;
      try {
        const response = await axios.get(`https://www.haomiaodata.com/api/company_detail/${companyId}`);
        this.companyDetail = response.data.data;
        // 确保 concat_email_list 是一个数组
        if (this.companyDetail && !Array.isArray(this.companyDetail.concat_email_list)) {
          this.companyDetail.concat_email_list = this.companyDetail.concat_email_list ? [this.companyDetail.concat_email_list] : [];
        }
      } catch (error) {
        console.error('获取公司详情出错:', error);
        this.$message.error('获取公司详情失败，请稍后重试');
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.company-detail-page {
  padding: 20px;
}

.detail-card {
  margin-top: 20px;
}

.box-card {
  margin-bottom: 20px;
}

.company-history {
  white-space: pre-wrap;
  line-height: 1.6;
}

.el-descriptions {
  margin-bottom: 20px;
}

h2, h3 {
  margin-bottom: 15px;
}

.el-icon-message {
  margin-right: 5px;
  color: #409EFF;
}
</style>
